import React, { useEffect } from 'react';
import Slider from "react-slick";
import ProductCardFinwell from '../card/ProductCardFinwell';
import { useDispatch, useSelector } from 'react-redux';
import { getMyCoursesClear, getProductCategoriesData, getProductCategoriesDataClear } from '../../../redux/courses/actions';
import { clickStreamUser, convertHoursToMins, convertTimeFormat, getAssetType, getProcureInfo, goToLPDetailUtil, ProductCardPriceInfo, redirectToPageUtil, SessionKeys } from '../../../utils/AppUtils';
import _ from 'lodash';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { duration } from 'moment';
import { getNonMyOBLPListing, getNonMyOBLPListingClear } from '../../../redux/learningPath/actions';
import CONFIG from '../../../utils/config';
import API_LIST from '../../../utils/apiList';
import Loader from '../../../components/Loader/Loader';
const settings1 = {
  dots: true,
  arrows: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: false,
  responsive: [
    {
      breakpoint: 992,
      settings: { slidesToShow: 1 }
    }
  ]
};
const ContinueJourney = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authBroker = useSelector((state) => state.auth.authBroker);
  var myCourseRes = useSelector((state) => state.courses.productCategoriesData);
  const myNonOblpListing = useSelector((state) => state.learningPath.myNonOblpListing);
  const [myAssetList, setMyAssetList] = React.useState([]);
  const [lpListing, setLPListing] = React.useState([]);
  const [courseData, setCourseData] = React.useState({});
  const [loading, setLoading] = React.useState(false);


  useEffect(() => {
    fetchNonMyOBLPList();

    let req = {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          category_id: [],
          provider_id: "",
          search: "",
          sort: 1,
          page_size: 100,
          page: 1,
          type: "continue",
        };
    // clickStreamUser("ContinueYourJourneyAsset", req, authBroker);
    setLoading(true);
    dispatch(
      getProductCategoriesData({
        module: "getProductCategoriesDataMyCourse",
        postData: req,
      })
    );
  }, [dispatch])




  useEffect(() => {
    if (!_.isEmpty(myCourseRes)) {
      setLoading(false);
      console.log("MY COURSES", myCourseRes);
      if (myCourseRes.status === "success") {
        const cListPayload = myCourseRes.payload.payload;
        if (!_.isEmpty(cListPayload)) {
          const cList = cListPayload.courseList;
          for (let course of cList) {
            if (course.durationUnit === "Hours") {
              course.duration = convertHoursToMins(course.duration);
            }
            course.duration = convertTimeFormat(course.duration, true);
            course.durationUnit = "";
          }
          console.log("MY COURSES--", cList);

          let prodArr = [];
          for (let course of cList) {
            let tags = [];
            let btnTitle = t("Start course");
            if (course.provider?.provider_display_name) {
              tags.push(course.provider.provider_display_name);
            }
            tags.push("Course");
            if (course.lessons) {
              tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
            }
            if (course.duration) {
              tags.push(`${course.duration} ${course.durationUnit}`);
            }
            if (course.views) {
              tags.push(`${course.views} ${t("View")}${course.views > 1 ? "s" : ""}`);
            }
            if (course.crs_progress > 0 && course.crs_progress < 100) {
              btnTitle = t("Resume course");
            } else if (course.crs_progress >= 100) {
              btnTitle = t("Revisit course");
            }
            let priceInfo = getProcureInfo(course.purchased_info);
            course.is_home = true;
            setMyAssetList([]);
            prodArr.push({
              id: course?.courseId,
              is_like: course?.is_like ? course?.is_like : false,
              is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
              dbId: course?.list_id,
              productType: course?.typ,
              productOrigin: course?.source,
              title: course.name,
              logoURL: course.provider?.provider_img
                ? course.provider?.provider_img
                : "",
              bannerURL: course.imageURL,
              tagsArray: tags,
              description: course.short_description,
              btnTitle: btnTitle,
              progress: course.crs_progress,
              showLikeMenu: true,
              btnAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
              descAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
              bannerAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
              footerLineComp: "",
              showHeader: true,
              showBody: course.short_description ? true : false,
              showFooter: true,
              showProgress: true,
              cardClassName: "",
              rightBtnIcon: "/images/arrow-right.svg",
              lefttBtnIcon: "",
              priceInfo,
              status: course.crs_status,
              asset_type: course.asset_name,
              duration: course.duration,
              monitoring_name: course.monitoring_name,
              asset_icon: course?.asset_icon,
              monitoring_icon: course?.monitoring_icon,
              isCoachPick:course?.is_coachpick
            });
          }
          setMyAssetList(prodArr);
          let tempAssetList = [...lpListing, ...prodArr];
          setMyAssetList(tempAssetList);

          dispatch(getProductCategoriesDataClear({}));

        }
      }

    }
  }, [myCourseRes]);

  const fetchNonMyOBLPList = () => {
    console.log("FETCH NON MY OBLP LIST");
    
    let req = {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          sort: 1,
          page_size: 12,
          page: 0,
          search: "",
          is_onboarding: 0,
          provider_id: "",
          isAll: false,
          language: "",
          type: "continue"
        };
    clickStreamUser("ContinueYourJourneyActionPath", req, authBroker);
    dispatch(
      getNonMyOBLPListing({
        URL: `${CONFIG.API_URL_BROKER}${API_LIST.BROKER_API.GET_MY_LP_LISTING}`,
        payload: req,
        isJSON: true,
        method: "post",
      })
    );
  };

  useEffect(() => {
    if (
      !_.isEmpty(myNonOblpListing)
    ) {
      setLoading(false);
      let responseList = myNonOblpListing;
      if (responseList.status === "success") {
        const payload = responseList.payload?.data;
        if (!_.isEmpty(payload)) {
          console.log("continueYourJourney: ", payload);
          formatLPData(payload);
        } else {
          setLPListing([]);
        }
      } else {
        setLPListing([]);
      }
      dispatch(getNonMyOBLPListingClear());
    }
  }, [myNonOblpListing]);

  const formatLPData = (lpData) => {
    let lpArr = [];
    let records = lpData.records;
    for (let lp of records) {
      let tags = [];
      let logoURL = "";
      let btnTitle = t("Explore");
      if (_.toNumber(lp.learn_progress) === 100) {
        btnTitle = t("Revisit");
      }
      if (
        _.toNumber(lp.learn_progress) > 1 &&
        _.toNumber(lp.learn_progress) < 100
      ) {
        btnTitle = t("Resume");
      }
      if (!_.isEmpty(lp.provider)) {
        tags.push(lp.provider.provider_display_name);
        logoURL = lp.provider.provider_img;
      }

      if (lp.product_type === "bundle") {
        tags.push(t("Combo"));
      } else {
        tags.push("Action Path");
      }

      if (lp.learningpath_count) {
        tags.push(
          `${lp.learningpath_count} ${t("Action Path")}${lp.learningpath_count > 1 ? "s" : ""
          }`
        );
      }
      if (lp.course_count) {
        tags.push(`${lp.course_count} ${t("Course")}${lp.course_count > 1 ? "s" : ""}`);
      }
      if (lp.video_count) {
        tags.push(`${lp.video_count} ${t("Video")}${lp.video_count > 1 ? "s" : ""}`);
      }
      if (lp.level_count) {
        tags.push(`${lp.level_count} ${t("Level")}${lp.level_count > 1 ? "s" : ""}`);
      }
      if (lp.event_count) {
        tags.push(`${lp.event_count} ${t("Event")}${lp.event_count > 1 ? "s" : ""}`);
      }
      if (lp.duration) {
        tags.push(`${convertTimeFormat(lp.duration, true)}`);
      }
      let priceInfo = getProcureInfo(lp.purchased_info);
      lp.priceInfo = priceInfo;

      lpArr.push({
        id: lp?.id,
        ecom_id: lp?.ecom_id,
        is_like: lp?.is_like ? lp?.is_like : false,
        is_bookmark: lp?.is_bookmark ? lp?.is_bookmark : false,
        is_wishlist: lp?.is_addtowishlist,
        dbId: lp?.list_id,
        productType: "learningpath",
        productOrigin: lp?.origin,
        title: lp.name,
        logoURL: logoURL,
        logoAlText: "LP",
        bannerURL: lp.imageURL,
        tagsArray: tags,
        description: lp.short_description,
        duration: convertTimeFormat(lp.duration, true),
        showHeader: true,
        showProviderIcon: true,
        showLikeMenu: true,
        showPlayButton: false,
        showProgress: true,
        showBody: false,
        showFooter: true,
        progress: lp.learn_progress,
        btnTitle: btnTitle,
        btnAction: () => goToLPDetailUtil(lp, navigate, 0),
        descAction: () => { },
        bannerAction: () => goToLPDetailUtil(lp, navigate, 0),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        isLoading: false,
        priceInfo: priceInfo,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        isBundle: lp?.product_type === "bundle",
        bundles: lp?.bundles,
        status: lp?.status,
        asset_type: "Action Path",
        monitoring_name:lp?.monitoring_name,
        asset_icon: "/images/finwell-img/extension.svg",
        isCoachPick:lp?.is_coachpick
        
      });
    }

    setLPListing(lpArr);
    let tempAssetList = [...myAssetList, ...lpArr];
    setMyAssetList(tempAssetList);
  };


  return (
    <>
    <Loader start = {loading} />
      {!_.isEmpty(myAssetList) && myAssetList?.length > 0 ? <section aria-labelledby="continue-journey-heading" className='mb-2rem'>
        <div class="continue-section">
          <div class="left">
            <h3>Continue your journey</h3>
            <p>Pick up right where your learning paused</p>
          </div>
          <div class="right cursor-pointer">
            <a 
            aria-label='View learning history'
            className='cursor-pointer'
            tabIndex={0} onClick={() => {
              navigate(
                `/profile/edit?section=edit&tab=2&user_id=${authBroker?.payload?.user.user_id
                }`
              );
            }}>View learning history</a>
          </div>
        </div>
        <Slider {...settings1} className="slider-gap">
          {
            myAssetList.map((course, i) => {
              console.log("COURSE334454", course);
              return (
               
                    <ProductCardFinwell
                      {...course}
                      key={`course-${i + 1}`}
                    />
                
              );
            })
          }


        </Slider>
      </section> : ""}
    </>
  );
};

export default ContinueJourney;